define([
    "dojo/_base/array",
    "dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/AddPath",
    "csi/table/Widget",
    "./SelectSetHelper"
], function(array,declare,lang,AddPath,Widget,SelectSetHelper) {

    return declare(Widget, {
		_resolveView: function() {
			var	node = this.getViewNode();

			if(node && ["Season","Category1","Category2","Collection"].indexOf(node.$Type) != -1) {
				var pathToAdd = lang.mixin(new AddPath(), {
					m_path: "Child:SelectSets"
				});
				this.relRoot.m_addPaths.push(pathToAdd);
			}

			this._resolveViewFilter();
			this.inherited(arguments);
		},
		
		_resolveViewFilter: function() {
			// summary: substitute correct attribute Value in filter
			var r = this.relRoot;
			
			array.some(r.m_filters, function(f) {
				if (f.getAttribute("RValue") == "${0}") {
					var type = this.viewParent ? SelectSetHelper.SELECT_SET_TYPE_BY_PARENT_VIEW_URL[this.viewParent.getViewURL()]: null;
					if (type) {
						f.setAttribute("RValue", SelectSetHelper.SUBTYPE_URL_PREFIX + type);
					} else {
						r.m_filters.dele(f);
					}
					return true;
				}
				
				return false;
			}, this);
		},

		setViewNode: function(/*Node*/node, /*Boolean*/bSaveSelections) {
			// summary: set custom view key based on subtype
			// except for site level view, that shows all subttypes of selectSets
			if (this.viewParent) {
				var type = SelectSetHelper.resolveSelectSetType(this.viewParent.getViewURL());
				if (type != SelectSetHelper.SITE_LEVEL_VIEW_NODE_TYPE) {
					this.prefKey = this.defView.getKey(type);
				}
			}
			   
			this.inherited(arguments);
		}
    });
});